import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const tagsConfig = {
  ...tagsCommonConfig,
  theme: {
    popupTagBgColor: '#35224D',
    popupTagColor: brandTheme.textSecondary,
    filterBgColor: '#35224D',
    filterActiveBgColor: brandTheme.primaryColor,
    filterColor: brandTheme.textSecondary,
    filterActiveColor: brandTheme.textInverse,
  },
} satisfies TagsPageConfig
